
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const StickyCTA = () => {
  // Nous allons retourner un élément vide puisque le client souhaite supprimer ce composant
  return null;
};

export default StickyCTA;
